'use client';

import { Box, styled } from '@mui/material';

const SeoResponsiveBox = styled(Box)(({ theme }) => ({
  '& .desktop-only': {
    display: 'block',
    [theme.breakpoints.down('md')]: { display: 'none' }
  },
  '& .mobile-only': {
    display: 'none',
    [theme.breakpoints.down('md')]: { display: 'block' }
  }
}));

export default SeoResponsiveBox;
